





























































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Product, ProductStatus } from '@/api';
import InformationRow from '@/components/display/information-row.vue';
import { ProductOrdwayAttributes } from '@/models/ordway';
import ExternalLinkButton from '@/components/elements/buttons/external-link-button.vue';
import { OrdwayService } from '@/services/ordway-service';
import Toast from '@/components/display/toast.vue';
import BillingSetupButton from '@/components/billing-setup-form/billing-setup-button.vue';

@Component({
	computed: {
		ProductStatus() {
			return ProductStatus;
		},
	},
	components: { BillingSetupButton, ExternalLinkButton, InformationRow },
})
export default class PlanRow extends Vue {
	private syncing: boolean = false;

	@Prop({ required: true })
	public productOrdwayAttributes?: ProductOrdwayAttributes | null;

	@Prop({ required: true, type: Object })
	public product!: Product;

	@Emit('loadProduct')
	public onLoadProduct(): void {}

	public async syncOrdwayDraftSubscription() {
		if (this.product?.id == null) return;
		this.syncing = true;
		await OrdwayService.syncOrdwayDraftSubscription(this.product.id!);
		this.onLoadProduct();
		this.syncing = false;
		new Toast().makeToast('Ordway Draft Subscription Synchronised', 'Successful', 'success');
	}

	public get ordwayButtonVariant(): string {
		return this.productOrdwayAttributes?.ordwaySubscriptionStatus === 'Active'
			? 'success'
			: 'warning';
	}

	public get ordwayBaseUrl(): string {
		return process.env.VUE_APP_ORDWAY_BASE_URL;
	}
}
